function checkBreakPoint() {
  w = $(window).width();
  if (w <= 500) {
    // スマホ向け（500px以下のとき）
    $(".slider-3").not(".slick-initialized").slick({
      //スライドさせる
      autoplay: false,
      autoplaySpeed: 6000,
      centerMode: false,
      centerPadding: "false",
      autoplay: false, //自動的に動き出すか。初期値はfalse。
      autoplaySpeed: 5000,
      infinite: false, //スライドをループさせるかどうか。初期値はtrue。
      arrows: true, // 矢印
      dots: true,
      slidesToShow: 1, //スライドを画面に3枚見せる
      slidesToScroll: 1, //1回のスクロールで3枚の写真を移動して見せる
      prevArrow:
        '<div class="slick-prev-container slick-prev-next-container"><div class="slick-prev"></div></div>', //矢印部分PreviewのHTMLを変更
      nextArrow:
        '<div class="slick-next-container slick-prev-next-container"><div class="slick-next"></div></div>', //矢印部分NextのHTMLを変更
    });
  } else {
    // PC向け
    $(".slider-3.slick-initialized").slick("unslick");
  }
}
// ウインドウがリサイズする度にチェック
$(window).resize(function () {
  checkBreakPoint();
});
// 初回チェック
checkBreakPoint();
